var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApiClient } from "@/context/ApiClientContext";
import { BiCategory } from "react-icons/bi";
import "./ProductCategory.css";
import "@/pages/home/HomePage.css";
import { categoryImagesMap } from "@/utils/categoryImagesMap";
const ProductCategory = ({ propsLimit, propsSort, }) => {
    const apiClient = useApiClient();
    const [categories, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchProducts = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const arg = {
                    limit: propsLimit,
                    sort: propsSort,
                };
                const productsData = yield apiClient.getAllCategories(arg);
                setProducts(productsData.results);
                setLoading(false);
            }
            catch (err) {
                setError(err.message);
                setLoading(false);
            }
        });
        fetchProducts();
    }, [apiClient, propsLimit, propsSort]);
    if (loading)
        return _jsx("div", { className: "loading-container", children: "Loading..." });
    if (error)
        return _jsxs("div", { className: "main-content", children: ["Error: ", error] });
    return (_jsx("div", { className: "cards-container", children: categories.map((category) => {
            const categoryKey = category.key.toLowerCase();
            const categoryImage = categoryImagesMap[categoryKey];
            return (_jsx("div", { className: "category-cards-item", children: _jsxs(Link, { to: "/category/" + category.key, children: [_jsx("div", { className: "cards-item-img", children: categoryImage ? (_jsx("img", { src: categoryImage, alt: category.name["en-US"], className: "category-image" })) : (_jsx(BiCategory, { className: "img__category" })) }), _jsx("div", { className: "cards-category-name cards-item-text", children: _jsx("h2", { children: category.name["en-US"] }) })] }) }, category.id));
        }) }));
};
export default ProductCategory;
